import React from 'react';
import { CelebrationOverlayProps } from '../../../presentation/GamePresentationTypes';
import { BostonCelebrationOverlay } from '../../../components/Celebration/BostonCelebrationOverlay';
import { BostonTrainAnimation } from '../../../components/Celebration/BostonTrainAnimation';
import { getTeamForSeat } from '../../../engine/gameConfigHelpers';

/**
 * Bid Whist-specific Hand-End Celebration Overlay.
 *
 * Owned exclusively by the Bid Whist module:
 * Houses the legendary Boston Train ("All Aboard to Boston / Express 77 / ATL -> BOS")
 * and the cascading golden sparkles & firework bursts.
 */
export const BidWhistCelebrationOverlay: React.FC<CelebrationOverlayProps> = ({
  isOpen,
  isUserTeam = true,
  winningTeam = 1,
  gameState,
}) => {
  const losingPlayers = React.useMemo(() => {
    const losers = gameState?.seats?.filter(
      (p, idx): p is NonNullable<typeof p> => {
        if (!p) return false;
        const playerTeam = p.team ?? getTeamForSeat(idx);
        return playerTeam !== winningTeam;
      }
    ) || [];

    return losers.map((p) => ({
      name: p.name,
      avatarUrl: p.avatarUrl || p.originalAvatarUrl || undefined,
      isBot: Boolean(p.isBot),
    }));
  }, [gameState?.seats, winningTeam]);

  return (
    <>
      <BostonCelebrationOverlay
        isOpen={isOpen}
        isUserTeam={isUserTeam}
      />
      <BostonTrainAnimation
        isOpen={isOpen}
        isUserTeam={isUserTeam}
        winningTeam={winningTeam}
        losers={losingPlayers}
      />
    </>
  );
};
